export default function ({ $auth, route, redirect }) {
    if ($auth.user.features.agent) {
        return redirect('/Ai/Chat')
    }
}
